export const taxNumberMask = {
  blocks: [8, 1, 2],
  delimiter: "-",
  numericOnly: false,
};
